import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, CardMedia } from '@mui/material';
import productImage from '../../assets/home/product2.png';
import { useMediaQueries } from '../../usecontext/UseProvider';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination } from 'swiper/modules';
import { getOurCategoriesItemsByID } from '../../services/OurCategories';

const SimilarProducts = ({ productData }) => {
    const { isSmallScreen, isMediumScreen, isLargeScreen } = useMediaQueries();
    const [similarData, setSimilarData] = useState();

    const fetchCategoryProducts = async () => {
        try {
            const response = await getOurCategoriesItemsByID(productData?.createdBy?._id, { skip: 0, limit: 0 });
            setSimilarData(response?.categoryItems);
        } catch (error) {
            console.error("Error fetching similar products:", error);
        }
    };

    useEffect(() => {
        if (productData?.createdBy?._id) {
            fetchCategoryProducts();
        }
    }, [productData?.createdBy?._id])


    return (
        <Box sx={{ py: { lg: 5, xs: 3 }, textAlign: 'center', maxWidth: { lg: '1200px' }, mx: isSmallScreen ? 0 : isLargeScreen ? 5 : 'auto' }}>
            <Typography data-aos="fade-up" variant={isSmallScreen ? 'h6' : isMediumScreen ? 'h5' : 'h4'} sx={{ fontWeight: 700 }} gutterBottom>
                Similar Product
            </Typography>
            <Typography data-aos="fade-up" variant="subtitle1" sx={{ mb: { lg: 6, xs: 3 } }}>
                Look at Our Most New Additions!
            </Typography>

            {/* Swiper Container */}
            {similarData?.length > 0 &&
                <Swiper
                    className="product-slider"
                    style={{ paddingBottom: '3rem' }}
                    modules={[Pagination]}
                    loop={true}
                    spaceBetween={isLargeScreen ? 20 : 0} // Space between slides
                    pagination={{ clickable: true }} // Enable pagination
                    breakpoints={{
                        0: {
                            slidesPerView: (similarData?.length || 0) < 4 ? 1 : 1,
                            spaceBetween: 10,
                        },
                        768: {
                            slidesPerView: (similarData?.length || 0) < 4 ? 1 : 2,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: (similarData?.length || 0) < 4 ? 1 : 3,
                            spaceBetween: 30,
                        },
                    }}
                    data-aos="fade-up"
                >
                    {similarData?.map((product, index) => (
                        <SwiperSlide key={index} >
                            <Card
                                sx={{
                                    borderRadius: '0',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                    position: 'relative',
                                    overflow: 'visible',
                                    boxShadow: 'none',
                                }}
                            >
                                <CardMedia
                                    className="product-image"
                                    component="img"
                                    image={product?.images[0]?.url}
                                    alt={"Product"}
                                    sx={{ borderRadius: '0', height: isLargeScreen ? '320px' : '300px', width: isMediumScreen ? '320px' : isLargeScreen ? '280px' : '340px' }}
                                />
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        left: '50%',
                                        transform: 'translate(-50%, -0%)',
                                        bottom: '10%', textAlign: 'center',
                                        color: '#000',
                                        width: '80%',
                                        backgroundColor: '#fff',
                                    }}
                                >
                                    <Typography className="title" sx={{ py: 1, pb: 1 }}>
                                        {product.name}
                                    </Typography>
                                </Box>
                            </Card>
                        </SwiperSlide>
                    ))}
                </Swiper>}
        </Box >
    );
};

export default SimilarProducts;